import { computed } from 'vue'

import { defineStore } from 'pinia'

export const useStateStore = defineStore('state', {
  state: (): any => {
    return {
      state: {}
    }
  },
  getters: {
    get: (state) => {
      return (id: string) => {
        if (!(id in state.state)) state.state[id] = {}
        return state.state[id]
      }
    },
    link: (state) => {
      return (id: string) => {
        return computed(() => state.get(id))
      }
    },
    getBlockGroupNameValue: (state) => {
      return (id: string, group: string, name: string) => {
        return computed(() => {
          return state.state[id] && state.state[id][group] && state.state[id][group][name];
        })
      }
    },
    getBlockGroupNameValueWithDefault: (state) => {
      return (id: string, group: string, name: string, defaultValue: any) => {
        return computed(() => {
          return (state.state[id] && state.state[id][group] && state.state[id][group][name]) ?? defaultValue;
        })
      }
    }
  },
  actions: {
    update(id: string, value: any) {
      if (!(id in this.state)) this.state[id] = {}

      for (const group of Object.keys(value)) {

        if (!(group in this.state[id])) this.state[id][group] = {}

        for (const name of Object.keys(value[group])) {
          this.state[id][group][name] = value[group][name]
        }
      }
    },
    updateFromBatch(batch: Record<string, any>) {
      for (const id of Object.keys(batch)) {
        this.update(id, batch[id]);
      }
    },
    updateBlockGroupNameValue(id: string, group: string, name: string, value: any) {
      if (!(id in this.state)) this.state[id] = {}

      if (!(group in this.state[id])) this.state[id][group] = {}

      this.state[id][group][name] = value
    }
  }
})
